const styles = {
  button: {
    alignItems: "center",
    display: "flex"
  },
  cogIcon: {
    marginLeft: 5
  },
  container: {
    alignItems: "center",
    display: "flex"
  },
  textWrapper: {
    fontSize: "12px",
    fontWeight: "700",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  }
};

export default styles;
